<template>
    <z-scrollDiv class="type-main" :style="{height:list_height+'px'}">
        <div class="type-slot">
            <slot></slot>
        </div>
    </z-scrollDiv>
</template>

<script>
export default {
    props:{
        max:{
            type:Number,
            default:4,
        },
        length:Number,
    },
    data(){
        return {
            activeIndex:0,
        }
    },
    computed:{
        list_height(){
            let num = 22;  //css默认高度
            if(this.length<this.max){
                return 22*this.length;
            }else{
                return 22*this.max;
            }
        }
    }
}
</script>

<style lang="less">
    .type-main {
        display: none;
        padding: 0;
        margin: 0;
        position: absolute;
        top: calc(~"100% - 10px");
        left: 50%;
        max-width:130px;
        transform: translateX(-50%);
        z-index: 3;
        background: #fff;
        white-space: nowrap; // border: 1px solid #ccc;
        box-shadow: 0px 0px 4px 0px rgba(128, 128, 128, 0.50);
        @li-h: 22px;
        // min-height:@li-h * 3;
        // max-height: @li-h * 6;
        // overflow: auto;
        .type-slot{
            >div {
                padding: 0 15px;
                font-weight: 300;
                font-size: 12px;
                height: @li-h;
                line-height: @li-h;
                background: #ffffff;
                transition: 0.3s;
                &:hover {
                    background: #8c97b2;
                    color: #fff;
                }
                &.active {
                    background: #8c97b2;
                    color: #fff;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// type-choose.vue?733ed44c